module.exports = __webpack_public_path__ + "static/img/5-1-4.cd31c567.jpg";